<div class="one-morning" *ngIf="employer">
	<section class="hero" [style.background-image]="heroBackgroundImage">
		<h2 [innerHTML]="heroHeadingText"></h2>
	</section>
	<section class="well-being">
		<div class="copy fade-in">
			<div class="pre-headline" [translate]="'home-wellbeing-preheadline'">A New Morning for Employee Wellness</div>
			<div class="headline" [translate]="'home-wellbeing-headline'">Your well-being matters.</div>
			<div class="text" [translate]="'home-wellbeing-text'">When the "good" in "good morning" feels hollow. When persevering seems impossible. When your to-do list is miles long, and getting help is yet another time-consuming task. <span class="notranslate">One Morning</span> has your back. Because life's a struggle, but finding help shouldn't be.</div>
		</div>
	</section>
	<section class="video">
		<video poster="/assets/images/home-video-poster.png" controls crossorigin="anonymous" [interact]="{ engagementTypeID: 1, resource: 'Home Page Hero Video' }">
			<source [src]="env.homeVideoURL" type="video/mp4" />
			<track src="https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization-en.vtt" kind="subtitles" srclang="en" label="English" />
			<track src="https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization-es.vtt" kind="subtitles" srclang="es" label="Español" [attr.default]="currentLanguage === 'es' ? '' : null" />
			<track src="https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization-zh-Hans.vtt" kind="subtitles" srclang="zh-Hans" label="中文 (简体)" [attr.default]="currentLanguage === 'zh-Hans' ? '' : null" />
			<track src="https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization-ar.vtt" kind="subtitles" srclang="ar" label="العربية" [attr.default]="currentLanguage === 'ar' ? '' : null" />
			<track src="https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization-de.vtt" kind="subtitles" srclang="de" label="Deutsch" [attr.default]="currentLanguage === 'de' ? '' : null" />
		</video>
	</section>
	<section class="new-light" *ngIf="eapData as data">
		<div class="col fade-in">
			<div class="headline" [translate]="'home-support-headline'">Get support anytime.</div>
			<ng-container *ngIf="data['Get Support Anytime Override']; else defaultContent">
				<div [innerHTML]="formatContentWithLineBreaks(data['Get Support Anytime Override'])"></div>
			</ng-container>
			<ng-template #defaultContent>
				<p class="text" [innerHTML]="supportText1"></p>
				<p class="text" [innerHTML]="supportText2"></p>
				<p class="text" [innerHTML]="supportText3"></p>
			</ng-template>
			<div class="cta-buttons">
				<div class="cta-button-group" *ngIf="data['CTA Button 1 Type'] === 'Visit EAP'">
					<a class="cta" [href]="data['CTA Button 1 URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Home' }" [innerHTML]="cta1Text"></a>
					<span *ngIf="data['CTA Button 1 Group Code']"><b>{{ data['CTA Button 1 Group Code Label Override'] || enterGroupCodeText }}</b>:&nbsp;{{ data['CTA Button 1 Group Code'] }}</span>
				</div>
				<div class="cta-button-group" *ngIf="data['CTA Button 1 Type'] === 'Call EAP'">
					<a class="cta" [href]="'tel:' + sanitizePhone(data['CTA Button 1 Phone'])" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Home' }" [innerHTML]="cta1Text"></a>
					<span class="call-eap-number notranslate">{{ data['CTA Button 1 Phone'] }}</span>
				</div>
				<div class="cta-button-group" *ngIf="data['CTA Button 2 Type'] === 'Visit EAP'">
					<a class="cta" [href]="data['CTA Button 2 URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 2 - Home' }" [innerHTML]="cta2Text"></a>
					<span *ngIf="data['CTA Button 2 Group Code']"><b>{{ data['CTA Button 2 Group Code Label Override'] || enterGroupCodeText }}</b>:&nbsp;{{ data['CTA Button 2 Group Code'] }}</span>
				</div>
				<div class="cta-button-group" *ngIf="data['CTA Button 2 Type'] === 'Call EAP'">
					<a class="cta" [href]="'tel:' + sanitizePhone(data['CTA Button 2 Phone'])" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 2 - Home' }" [innerHTML]="cta2Text"></a>
					<span class="call-eap-number notranslate">{{ data['CTA Button 2 Phone'] }}</span>
				</div>
			</div>
		</div>
		<div class="col fade-in">
			<ul class="access">
				<li *ngIf="data['Free Visits']">
					<span>{{ data["Free Visits"] }}</span>
					<span [translate]="'home-free-visits-desc'">Free one-on-one counseling sessions per person per year.</span>
				</li>
				<li *ngIf="data['Toll Free Number']">
					<span>{{ data["Access"] || "24/7" }}</span>
					<span [innerHTML]="phoneAccessText"></span>
				</li>
				<li *ngIf="data['Text Phone Number']">
					<span><img src="/assets/images/mobile-phone.svg" /></span>
					<span [innerHTML]="textSupportText"></span>
				</li>
				<li *ngIf="data['Custom Content']">
					<span><img [src]="data['Custom Content Image'] || '/assets/images/information.svg'" /></span>
					<div class="om-custom-content" [innerHTML]="data['Custom Content']"></div>
				</li>
				<li *ngIf="data['Custom Content 2']">
					<span><img [src]="data['Custom Content 2 Image'] || '/assets/images/information.svg'" /></span>
					<div class="om-custom-content" [innerHTML]="data['Custom Content 2']"></div>
				</li>
				<li *ngIf="data['Custom Content 3']">
					<span><img [src]="data['Custom Content 3 Image'] || '/assets/images/information.svg'" /></span>
					<div class="om-custom-content" [innerHTML]="data['Custom Content 3']"></div>
				</li>
			</ul>
		</div>
	</section>

	<app-app-download *ngIf="content[4] as data" [data]="data" [eapUrl]="eapData['CTA Button 1 URL'] || ''" [eapPhone]="eapData['CTA Button 1 Phone'] || ''" [ctaType]="eapData['CTA Button 1 Type'] || ''" [groupCode]="eapData['CTA Button 1 Group Code'] || ''" [groupCodeLabel]="eapData['CTA Button 1 Group Code Label Override'] || ''"></app-app-download>

	<section class="learn-more fade-in">
		<div class="copy">
			<div class="headline" [translate]="'home-help-headline'">When you need help getting help.</div>
			<div class="text" [translate]="'home-help-text'">Whatever life throws at us &ndash; anxiety, loss, hardship &ndash; help is much closer than we think. No matter your circumstances, there is free, confidential support through your Employee Assistance Program. Don&rsquo;t wait until it&rsquo;s too hard to ask for help.</div>
			<div class="actions" *ngIf="eapData as data">
				<a *ngIf="data['CTA Button 1 Type'] === 'Visit EAP'" class="cta" [href]="data['CTA Button 1 URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Home Help' }" [innerHTML]="cta1Text"></a>
				<a *ngIf="data['CTA Button 1 Type'] === 'Call EAP'" class="cta" [href]="'tel:' + sanitizePhone(data['CTA Button 1 Phone'])" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Home Help' }" [innerHTML]="cta1Text"></a>
				<span *ngIf="data['CTA Button 1 Type'] === 'Call EAP'" class="call-eap-number notranslate">{{ data['CTA Button 1 Phone'] }}</span>
			</div>
		</div>
		<div class="img"></div>
	</section>

	<app-crisis-cards-section *ngIf="content[2]" [data]="content[2]" [employer]="employer"></app-crisis-cards-section>

	<div class="sunrise">
		<section class="quote fade-in">
			<ng-container *ngIf="content[1] as data">
				<div class="quote-container">
					<p class="quote-content">“{{ data["Quote"] }}”</p>
					<p class="attribution">— {{ data["Quote Source"] }}</p>
				</div>
			</ng-container>
		</section>
		<section class="video-cards fade-in" *ngIf="videoCards?.length">
			<div class="copy">
				<div class="headline" [translate]="'home-videos-headline'">Watch Real Stories</div>
				<div class="text" [translate]="'home-videos-text'">When people decide it's time to make a change, hope happens.</div>
			</div>
			<div class="video-card-holder">
				<p-carousel *ngIf="showCarousel" [value]="videoCards" [numVisible]="PAGE_SIZE" [circular]="false" [showIndicators]="true" [showNavigators]="false" (onPage)="onPageChange($event)" [ngClass]="{ 'first-page': carouselIndex <= 0, 'last-page': carouselIndex == videoCards.length - PAGE_SIZE || videoCards.length <= PAGE_SIZE }">
					<ng-template let-card pTemplate="item">
						<app-video-card [cardData]="card" (onPlay)="playVideo($event)"></app-video-card>
					</ng-template>
					<ng-template pTemplate="previousicon"> </ng-template>
					<ng-template pTemplate="nexticon"> </ng-template>
				</p-carousel>
			</div>
		</section>
	</div>

	<section class="outro">
		<div class="fade-in">
			<p [innerHTML]="outroText"></p>
			<div class="actions">
				<a class="cta" routerLink="/learn-more" [interact]="{ engagementTypeID: 4, resource: 'Learn More - Home Outro' }" [translate]="'home-outro-cta'">Learn More</a>
			</div>
		</div>
	</section>
</div>

<div class="video-player" *ngIf="activeVideo">
	<div class="video-content">
		<div class="close" (click)="closeVideo()"><span class="material-symbols-outlined">close</span></div>
		<h1 *ngIf="activeVideo.title">
			{{ activeVideo.title }}<span class="tag" *ngIf="activeVideo.tag">{{ activeVideo.tag }}</span>
		</h1>
		<iframe *ngIf="isVimeo(activeVideo.videoFile)" [src]="activeVideo.videoFile | safe : 'resourceUrl'" width="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen> </iframe>
		<video *ngIf="!isVimeo(activeVideo.videoFile)" controls autoplay crossorigin="anonymous" [interact]="{ engagementTypeID: 1, resource: activeVideo.title }">
			<source [src]="activeVideo.videoFile" type="video/mp4" />
			<track [src]="getVttUrl(activeVideo.videoFile, 'en')" kind="subtitles" srclang="en" label="English" />
			<track [src]="getVttUrl(activeVideo.videoFile, 'es')" kind="subtitles" srclang="es" label="Español" [attr.default]="currentLanguage === 'es' ? '' : null" />
			<track [src]="getVttUrl(activeVideo.videoFile, 'zh-Hans')" kind="subtitles" srclang="zh-Hans" label="中文 (简体)" [attr.default]="currentLanguage === 'zh-Hans' ? '' : null" />
			<track [src]="getVttUrl(activeVideo.videoFile, 'ar')" kind="subtitles" srclang="ar" label="العربية" [attr.default]="currentLanguage === 'ar' ? '' : null" />
			<track [src]="getVttUrl(activeVideo.videoFile, 'de')" kind="subtitles" srclang="de" label="German" [attr.default]="currentLanguage === 'de' ? '' : null" />
		</video>
		<p *ngIf="activeVideo.cardContent">{{ activeVideo.cardContent }}</p>
	</div>
</div>

<app-app-download-overlay
	*ngIf="content[4] && content[4]['Show This Section'] == 'true' && !overlayDismissed"
	[data]="content[4]"
	[employerPath]="path"
	[eapUrl]="eapData['CTA Button 1 URL'] || ''"
	[eapPhone]="eapData['CTA Button 1 Phone'] || ''"
	[ctaType]="eapData['CTA Button 1 Type'] || ''"
	[groupCode]="eapData['CTA Button 1 Group Code'] || ''"
	[groupCodeLabel]="eapData['CTA Button 1 Group Code Label Override'] || ''"
	(dismissed)="overlayDismissed = true">
</app-app-download-overlay>
